import { FadeProps, Theme, useTheme } from '@material-ui/core';
import styledFuncs from 'app/styles/styledFuncs';
import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Except, Merge } from 'type-fest';

const duration = 250;

type MeasurementProps = Required<Pick<Props, 'marginLeft'>>;

type DefaultStyleProps = {
  theme: Theme;
  inProp: boolean;
} & MeasurementProps &
  Required<Pick<Props, 'width' | 'marginRight'>>;
const defaultStyle = ({
  theme,
  inProp,
  width,
  marginLeft,
  marginRight,
}: DefaultStyleProps) => ({
  transition: styledFuncs.createTransition(
    ['opacity', 'width', 'margin-right'],
    inProp ? 1000 : 0
  )({ theme }),
  overflow: 'hidden' as const,
  opacity: 1,
  marginLeft,
  marginRight,
  width,
});

const transitionedStyle = ({ marginLeft }: MeasurementProps) => ({
  opacity: 0,
  marginRight: `-${marginLeft}`,
  width: '0px',
});

const transitionStyles = (p: MeasurementProps) => ({
  entering: {},
  entered: {},
  exiting: transitionedStyle(p),
  exited: transitionedStyle(p),
  unmounted: transitionedStyle(p),
});

type Props = Merge<
  Except<FadeProps, 'ref'>,
  {
    children?: React.ReactNode;
    in: boolean;
    width: string;
    marginRight?: string;
    marginLeft?: string;
  }
>;
export default function SlideInOnRight({
  in: inProp,
  children,
  width,
  marginRight = '0px',
  marginLeft = '0px',
  ...props
}: Props): JSX.Element {
  const theme = useTheme();
  const nodeRef = useRef(null);
  return (
    <CSSTransition
      timeout={duration}
      in={inProp}
      {...{ nodeRef }}
      {...props}
    >
      {state => (
        <div
          ref={nodeRef}
          style={{
            ...defaultStyle({
              inProp,
              theme,
              marginRight,
              marginLeft,
              width,
            }),
            ...transitionStyles({ marginLeft })[state],
          }}
        >
          {children}
        </div>
      )}
    </CSSTransition>
  );
}
